import '@babel/polyfill'
import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/tailwind.scss'
import './components'
import './filters'
import './libs'
import './chart-js-plugins'

Vue.config.productionTip = false
Vue.config.productionSourceMap = false

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    ignoreErrors: [
      'Request failed with status code 422',
      'Request failed with status code 404'
    ],
    dsn: 'https://594b482ce4cd420eb435ddde895db544@o398988.ingest.sentry.io/5368568',
    integrations: [new VueIntegration({ Vue, attachProps: true })]
  })
}
// define customer directives
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

new Vue({
  router,
  store,
  beforeCreate () {
    store.commit('init')
  },
  render: h => h(App)
}).$mount('#app')
